import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-first-date',
    templateUrl: './first-date.component.html',
    styleUrls: ['./first-date.component.scss']
})
export class FirstDateComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }
}
